
export default
{
    code:'BES_US_MAGNIT_GLOBAL',
    currencies: ['USD'],
    baskets: {
        includePublicBaskets: false,
        businessCodes: ['MAGNIT_GLOBAL_BASKET'],
        individualCodes: ['MAGNIT_GLOBAL_BASKET'],
    },
    emailDomains: ['magnitglobal.com', 'magnit.com','rightsourcingusa.com'],
    content:{
        logo: {
            link: 'https://magnitglobal.com/'
        },
        menu: {
            menuIconColor: true,
            url: 'https://magnitglobal.com/',
            business: {
                items: ['dashboard', 'myCalculator', 'projects', 'FAQ', 'myAccount']
            },
            individual: {
                items: ['dashboard', 'myCalculator', 'projects', 'FAQ', 'myAccount']
            },
        },
        myMovementPanel: {
            hideMovementInvitation: true,
            hideMovementCreation: true,
        },
        myTeamPanel: {
            hideOffsettingForPanel: true,
            items: ["teamStats"],
            hideUnnalocatedSeats: true,
            teamMemberListVisibility: 'ADMIN', // PUBLIC, TEAM, ADMIN
            defaultUnitType: "t",
            content: {
                borderStyle: true,
                pointsTitle: "Points earned for Climate Friendly actions",
                offsetTitle: "Offset equivalent in trees",
                treesTitle: "Tree growth years",
                totalOffset: true,
            }
        },
        signIn: {
            individual: {
                hideSocialMedia: true,
            }
        },
    },
}